export default __webpack_public_path__ + "static/media/frenchDark.466bed62.png";